import { match } from 'ts-pattern';
export const migrateToV2 = (state)=>{
    return state.map((entity)=>{
        return match(entity).returnType().with({
            type: 'Appliance'
        }, (entity)=>({
                ...entity,
                packageDepth: 0,
                packageHeight: 0,
                packageWidth: 0,
                packageWeight: 0
            })).with({
            type: 'Cabinet'
        }, (entity)=>({
                ...entity,
                packageDepth: 0,
                packageHeight: 0,
                packageWidth: 0,
                packageWeight: 0
            })).with({
            type: 'Part'
        }, (entity)=>({
                ...entity,
                packageDepth: 0,
                packageHeight: 0,
                packageWidth: 0,
                packageWeight: 0
            })).otherwise((other)=>other);
    });
};

//# sourceMappingURL=v02.js.map